<template>
  <div class="dsdiv">
    <div class="htmldiv">
      <div class="st fs28 fbold tcenter pt30 mb50">
        <div class="stborder dinline-block prelative">
          <div class="tt wd100 pabsolute">
            <div class="dinline-block fbold">
              <span class="tc11">专升本</span>教育
            </div>
          </div>
        </div>
      </div>
      <div class="cont pt5 fs0 pb20 tcenter">
        <EduImgItem :controller="'cedu'" v-for="(item,index) in info" v-if="index < 4" :key="index" :index="index" :item="item"/>
<!--        <EduListItem :controller="'cedu'" v-for="(item,index) in info.homeCategoryList" v-if="index < 3" :key="index" :index="index" :item="item"/>-->
      </div>
    </div>
  </div>
</template>

<script>
  import EduImgItem from './edu-img-item.vue'
  import EduListItem from './edu-list-item.vue'
  export default {
    name: "cedu",
    props: [
      'info'
    ],
    components: {
      EduImgItem,
      EduListItem,
    },
  }
</script>

<style scoped>
  .dsdiv .sdiv{margin: 0 5px 20px;width: 305px;height: 160px;}
</style>



// WEBPACK FOOTER //
// src/components/index/cedu.vue